module.exports = __webpack_public_path__ + "static/media/arrow.41f58d63.svg";